(() => {
  const sortSelect = document.querySelector('[data-ps-sort]');
  const facetForm = document.getElementById('ps-facet-form');

  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.assign(url.toString());
  });

  facetForm?.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    input.addEventListener('change', () => facetForm.requestSubmit());
  });
})();
